<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
    <span v-if="lang_a4all == 'arabic'">
      <privacy-arabic/>
    </span>
    <span v-else-if="lang_a4all == 'malay'">
      <privacy-malay/>
    </span>
    <span v-else-if="lang_a4all == 'greek'">
      <privacy-greek/>
    </span>
    <span v-else-if="lang_a4all == 'czech'">
      <privacy-czech/>
    </span>
    <span v-else-if="lang_a4all == 'bulgarian'">
      <privacy-bulgarian/>
    </span>
    <span v-else-if="lang_a4all == 'norwegian'">
      <privacy-norwegian/>
    </span>
    <span v-else-if="lang_a4all == 'swedish'">
        <privacy-swedish/>
    </span>
    <span v-else-if="lang_a4all == 'finnish'">
      <privacy-finnish/>
    </span>
    <span v-else-if="lang_a4all == 'romanian'">
      <privacy-romanian/>
    </span>
    <span v-else>
      <privacy-english/>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from "./../PrivacyPolicyEnglish";
import PrivacyPolicyArabic from "./../PrivacyPolicyArabic";
import PrivacyPolicyMalay from "./../PrivacyPolicyMalay";
import PrivacyPolicyGreek from "./../PrivacyPolicyGreek";
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './../PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_a4all", "country_a4all"]),
  components: {
    "privacy-english": PrivacyPolicyEnglish,
    "privacy-arabic": PrivacyPolicyArabic,
    "privacy-malay": PrivacyPolicyMalay,
    "privacy-greek": PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish
  },
  methods: {},
};
</script>

<style  lang="scss">
.apps4all {
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
    color: #fff;
  }
  .mobiFaq {
    margin: 25px 0px;
    color: #fff;
    .mobitxt {
      margin: 8px 0px;
      padding-left: 25px;
      color: #fff;
    }
    .mobiTitle {
      padding: 12px;
      background: #f1f1f1;
      color: #000;
      font-weight: 600;
    }
    li {
      font-size: 1rem;
      line-height: 1.2;
      font-weight: 300;
      margin-bottom: 8px;
    }
  }
}
.ar_layout {
  .apps4all {
    ul {
      text-align: right;
      direction: rtl;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/apps4all/PrivacyPolicy.vue